/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfAccessResponseViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfAccessResponseViewModelFromJSON,
    ResultOfAccessResponseViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface SecurityGetAccessRequest {
    intermediaryCode?: string | null;
}

/**
 * 
 */
export class SecurityApi extends runtime.BaseAPI {

    /**
     * Get the access information for the authenticated user
     */
    async securityGetAccessRaw(requestParameters: SecurityGetAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAccessResponseViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.intermediaryCode !== undefined) {
            queryParameters['intermediaryCode'] = requestParameters.intermediaryCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/securities/access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAccessResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Get the access information for the authenticated user
     */
    async securityGetAccess(requestParameters: SecurityGetAccessRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAccessResponseViewModel> {
        const response = await this.securityGetAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
